module.exports = __webpack_public_path__ + "img/app-lobby-menu.4a9d89a5.svg";